// CSV ↔ JSON Converter Tool — convert between CSV and JSON.
import { m } from "@/paraglide/messages";
import type { Tool } from "../index";

export const csvJsonTool: Tool = {
  id: "csv-json",
  name: () => m.cj_tool_name(),
  description: () => m.cj_tool_description(),
  icon: "🔄",
  basePath: "/csv-to-json",
  status: "stable",
  tags: ["csv", "json", "convert", "data"],
  pages: [
    {
      name: () => m.cj_nav_main(),
      path: "/csv-to-json",
      description: () => m.cj_nav_main_desc(),
      icon: "🔄",
    },
  ],
};
